module.exports = __webpack_public_path__ + "img/full2-min.ae8b458e.png";